import ComponentLoader from '@inventis/componentloader';

let loader = new ComponentLoader();
loader.loadComponentsWithinElement(document);
